import {
  UpsertPersonRequest,
  UpsertPersonResponse,
  UpsertPersonOptions,
  ApiClient,
} from "@quotientjs/core"
import type { Store } from "@/clients/store"

export class People {
  private apiClient: ApiClient
  private store: Store

  constructor(apiClient: ApiClient, store: Store) {
    this.apiClient = apiClient
    this.store = store
  }

  async upsert(options: UpsertPersonOptions): Promise<UpsertPersonResponse> {
    const request = new UpsertPersonRequest(options)
    const response = await this.apiClient.call(request)
    this.store.setPersonId(response.personId)
    return response
  }
}
